/**
 * @module acng/moviePool
 */
import angular from 'angular';
import angularTranslate, {provideTranslations} from 'acng/core/service/angular-translate.js';
import './attribute/index.js';
import './attribute/preview.js';
import './attribute/movie-preview-autoplay.js';
import './element/index.js';
import './config/routes.js';
import {Movie} from './model/movie.js';

const name = 'moviePool';

angular
  .module(name, [angularTranslate])
  .config(provideTranslations(name)) // still required for payment overlay reasons
  .factory('Movie', [() => Movie]); // still required for stock and feed
